import {publish} from '@/script/event.mjs'

export const canSaveMap = () => () => {
    return function () {
        if (! /^DRAFT|REVISE$/.test(this.data.mapStsCode)) {
            this.logger.error('只有草稿/修订状态的地图才能保存')
            return false
        }

        if (! this.permission.has('write')) {
            this.logger.error('没有保存权限')
            return false
        }

        return true
    }
}

export const saveMap = () => () => {
    return function () {
        return this.runAction(
            async () => {
                await this.actions.saveMap()
                publish(this, 'save')
            },

            {action: '保存地图'},
        )
    }
}
